import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, NEVER, Observable, of } from 'rxjs';

import { catchError, delay, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { UserContactInfo } from '../models/user-contact-info.model';
import { ContactType } from '../models/enum/contact-type.enum';
import { RequestUpdateService } from '../services/sections/job/request-update.service';
import { UserService } from '../services/sections/shared/user.service';

@Injectable({
	providedIn: 'root'
})
export class ContactsResolver implements Resolve<Observable<UserContactInfo[]>> {
	
	public static currentUserDetails: string;
	constructor(
		private router: Router,
		private userService: UserService,
		private requestUpdateService: RequestUpdateService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return forkJoin([
			this.userService.getVendorUsers(activatedRouteSnapshot.paramMap.get('token')),
			this.userService.getAssigneeUsers(activatedRouteSnapshot.paramMap.get('token')),
			this.requestUpdateService.getRequestUpdateCustomers(activatedRouteSnapshot.paramMap.get('token')),
			this.userService.getCurrentUserDetails(activatedRouteSnapshot.paramMap.get('token'))
		])
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap({
					next: ([vendors, assignees, customers, currentUserDetails]) => {

					}
				}),
				map(([vendors, assignees, customers, currentUserDetails]) => [
					...vendors.map(item => ({ ...item, contactType: ContactType.Vendor } as UserContactInfo)),
					...assignees.map(item => ({ ...item, contactType: ContactType.Assignee } as UserContactInfo)),
					...customers.map(item => ({ ...item, contactType: ContactType.Customer } as UserContactInfo))
				]
					.filter(item => !currentUserDetails || (item.userAccountId !== currentUserDetails.id))
					.sort((first, second) => {
						let result = first.lastName.localeCompare(second.lastName);

						if (result === 0) {
							result = first.firstName.localeCompare(second.firstName);
						}

						return result;
					}))
			);
	}
}
